


















































import Vue from 'vue'
import { ProductTextLanguage, UiLanguageItem, UiLanguageList } from '@/types'

interface LanguageListItem {
  id: number
  code: string
  text: string
}

interface ComponentData {
  languageList: LanguageListItem[]
  isTabs: boolean
  tab: number
  areaHeight: number
}

export default Vue.extend({
  name: 'ProductTextLanguagesDialog',

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false
    },
    isEdit: Boolean,
    languagesDialogData: Array as () => ProductTextLanguage[]
  },

  data (): ComponentData {
    return {
      languageList: [],
      isTabs: false,
      tab: 0,
      areaHeight: 200
    }
  },

  watch: {
    isTabs (newVal: boolean): void {
      if (newVal) {
        this.areaHeight = (this.$refs.cardText as HTMLElement).clientHeight - 72
      }
    },
  },

  computed: {
    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onFormSubmit (): void {
      const payload: ProductTextLanguage[] = this.languageList.map((item: LanguageListItem) => {
        return {
          languageId: item.id,
          text: item.text
        }
      })

      this.$emit('save', payload)
    }
  },

  mounted () {
    this.languageList = this.uiLanguageList.map((item: UiLanguageItem) => {
      return {id: item.syzId ,code: item.code, text: ''}
    })
    this.languagesDialogData.forEach((item: ProductTextLanguage) => {
      let foundItem: LanguageListItem | undefined = this.languageList.find((i: LanguageListItem) => i.id === item.languageId)
      if(foundItem) {
        foundItem.text = item.text ? item.text : ''
      }
    })

    if(this.isEdit) {
      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField[0]) {
          focusedField[0].focus()
        }
      }, 0)
    }
  }
})
